import { useEffect } from 'react'
import { useAuthStore } from '@/stores/authStore'
import { useUIStore } from '@/stores/uiStore'
import websocketService from '@/services/websocket'

export function useWebSocket() {
  const { isAuthenticated } = useAuthStore()
  const { connectionStatus } = useUIStore()

  useEffect(() => {
    if (isAuthenticated) {
      websocketService.connect()
    } else {
      websocketService.disconnect()
    }

    // Cleanup on unmount
    return () => {
      websocketService.disconnect()
    }
  }, [isAuthenticated])

  return {
    isConnected: connectionStatus === 'connected',
    connectionStatus,
    subscribe: websocketService.subscribeTo.bind(websocketService),
    unsubscribe: websocketService.unsubscribeFrom.bind(websocketService),
  }
}